import { RequestCreditLimitIncreaseCTA } from "./ctas";
export var RequestCreditLimitIncreaseIA = function RequestCreditLimitIncreaseIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [SUBMIT_REQUEST_USING_BUTTON(strictLocalize), PLEASE_NOTE(strictLocalize), TIMELINE(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return RequestCreditLimitIncreaseCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _RequestCreditLimitIn, _RequestCreditLimitIn2;
        return (_RequestCreditLimitIn = (_RequestCreditLimitIn2 = RequestCreditLimitIncreaseCTA(strictLocalize)).getLink) === null || _RequestCreditLimitIn === void 0 ? void 0 : _RequestCreditLimitIn.call(_RequestCreditLimitIn2);
      }
    }
  };
};
var REQUEST_CREDIT_LIMIT_INCREASE = function REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize) {
  return strictLocalize({
    id: "ugdDrA",
    defaultMessage: [{
      "type": 0,
      "value": "Solicitar aumento do limite de crédito"
    }]
  });
};
var SUBMIT_REQUEST_USING_BUTTON = function SUBMIT_REQUEST_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "LkoWL2",
    defaultMessage: [{
      "type": 0,
      "value": "Se quiser candidatar-se a um aumento do limite, clique no botão abaixo para enviar um pedido."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "lRQgRb",
    defaultMessage: [{
      "type": 0,
      "value": "Tenha em atenção que, se solicitou um aumento nos últimos 3 meses, a sua conta pode não ter este botão e, em vez disso, exigir uma análise manual da nossa equipa de pagamentos."
    }]
  });
};
var TIMELINE = function TIMELINE(strictLocalize) {
  return strictLocalize({
    id: "Jl6C3w",
    defaultMessage: [{
      "type": 0,
      "value": "Analisaremos o pedido e, normalmente, receberá uma resposta no prazo de 3 a 7 dias úteis."
    }]
  });
};